import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';
import { PHONE_TEL, WHATSAPP } from '../../data/contact';

// Always-visible Call · WhatsApp · Pay Premium bar on phones.
export default function MobileActionBar() {
  const { t } = useLang();
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 grid grid-cols-3 text-xs font-semibold pb-[env(safe-area-inset-bottom)]">
      <a href={PHONE_TEL} className="py-3 flex flex-col items-center gap-0.5 text-ink">📞<span>{t('mbCall')}</span></a>
      <a href={WHATSAPP} className="py-3 flex flex-col items-center gap-0.5 text-emerald-600">💬<span>WhatsApp</span></a>
      <Link to="/pay-premium" className="py-3 flex flex-col items-center gap-0.5 bg-saffron text-white">₹<span>{t('mbPay')}</span></Link>
    </div>
  );
}
